import { Box } from '../../../components/UI-CHAKRA/Box';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { FaExclamationCircle } from 'react-icons/fa';
import { themeColors } from '../../../shared/theme/themeColors';

export interface PrescriptionSendingMethodInformativeProps {
  disableWhatsapp: boolean;
  sendSMS: boolean;
  disableEmail: boolean;
  blockWhatsappWeb: boolean;
}
export function PrescriptionSendingMethodInformative(props: PrescriptionSendingMethodInformativeProps) {
  const { disableWhatsapp, sendSMS, disableEmail, blockWhatsappWeb } = props;

  const messageConfigs = [
    {
      conditions: [!sendSMS && disableEmail && !disableWhatsapp && blockWhatsappWeb],
      message: 'O envio ocorrerá por WhatsApp.',
    },
    {
      conditions: [!sendSMS && disableEmail && disableWhatsapp && !blockWhatsappWeb],
      message: 'Você pode enviar via WhatsApp Web.',
    },
    {
      conditions: [sendSMS && !disableEmail && disableWhatsapp && blockWhatsappWeb],
      message: 'O envio de SMS é automático. Você pode optar por enviar também via Email.',
    },
    {
      conditions: [sendSMS && disableEmail && disableWhatsapp && !blockWhatsappWeb],
      message: 'O envio de SMS é automático. Você pode optar por enviar também via WhatsApp Web.',
    },
    {
      conditions: [sendSMS && disableEmail && disableWhatsapp && blockWhatsappWeb],
      message: 'O envio de SMS é automático.',
    },
    {
      conditions: [sendSMS && !disableEmail && !disableWhatsapp && !blockWhatsappWeb],
      message: 'O envio de SMS é automático. Você pode optar por enviar também via WhatsApp Web e Email.',
    },
  ];

  const getMessage = () => {
    for (const config of messageConfigs) {
      if (config.conditions.every((condition) => condition)) {
        return config.message;
      }
    }
    return '';
  };

  return (
    <Box mt={'5px'}>
      <Flex alignItems={'flex-start'}>
        <Box mt={'4px'}>
          <FaExclamationCircle color={themeColors.info.main} style={{ marginRight: 4, width: 12, height: 12 }} />
        </Box>
        <Box>
          <Text color={'#868E96'} fontSize={'12px'}>
            {getMessage()}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
